module.exports = __webpack_public_path__ + "static/LayerDesktop-9c4bf6c0554964eab5d98d8b28c73c01.png";